import { createAuthClient } from 'better-auth/client'

/**
 * Better Auth's client, pointed at this Worker. Same origin, so the cookie it
 * sets is the one every other request already sends.
 */
export const authClient = createAuthClient({ basePath: '/api/auth' })

/** A Better Auth error, or a network failure, as one sentence for a person. */
export function authMessage(error: { message?: string; code?: string; status?: number } | null | undefined): string {
  if (!error) return 'Something went wrong.'
  switch (error.code) {
    case 'INVALID_EMAIL_OR_PASSWORD':
      return 'That email and password did not match.'
    case 'EMAIL_NOT_VERIFIED':
      return 'Confirm your email first — we just sent the link again.'
    case 'INVALID_TOKEN':
      return 'That link has expired or was already used. Ask for a new one.'
    case 'PASSWORD_TOO_SHORT':
      return 'Use at least 8 characters.'
    default:
      return error.message || 'Something went wrong.'
  }
}
